import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from './../../services/app.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../models/user.model';
import { GenericModel } from '../../models/generic.model'
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navbar-admin',
  templateUrl: './navbar-admin.component.html',
  styleUrls: ['./navbar-admin.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarAdminComponent implements OnInit {
  
  constructor(
    private appService: AppService,
    private userService: UserService,) {
  }

  isCollapsed = true;
  orgName: string;
  userDetail: GenericModel<User>;
  userId: string;
  profilePicUrl: string = '';
  sidebarPinned: boolean;

  ngOnInit() {
    console.log('*****NavbarAdminComponent****');
    //this.getUserActivity();
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
    this.sidebarPinned = this.appService.isSidebarPinned;
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
}
